import { supabase } from './supabase'

interface AppNotificationInput {
  organizationId: string
  clientId: string
  audience: 'business' | 'client'
  title: string
  body: string
  appointmentId?: string | null
}

export async function createAppNotification(input: AppNotificationInput) {
  const id = crypto.randomUUID()
  const { error } = await supabase.from('app_notifications').insert({
    id,
    organization_id: input.organizationId,
    client_id: input.clientId,
    audience: input.audience,
    title: input.title,
    body: input.body,
    created_at: new Date().toISOString(),
    is_read: false,
    appointment_id: input.appointmentId ?? null,
  })
  if (error) throw error

  const { error: dispatchError } = await supabase.functions.invoke('dispatch-notifications', {
    body: { notification_ids: [id] },
  })
  if (dispatchError) throw dispatchError

  return id
}
